<template>
    <button class="button" v-bind:class="{['variant-'+variant]: variant, ['button-'+width]: width}" v-if="variant == 'social-facebook'">
        <svgicon name="facebook" /><slot></slot>
    </button>
    <button class="button" v-bind:class="{['variant-'+variant]: variant, ['button-'+width]: width}" v-else-if="variant == 'social-linkedin'">
        <svgicon name="linkedin" /><slot></slot>
    </button>
    <button class="button" v-bind:class="{['variant-'+variant]: variant, ['button-'+width]: width}" v-else-if="variant == 'social-instagram'">
        <svgicon name="instagram" /><slot></slot>
    </button>
    <button class="button" v-bind:class="{['variant-'+variant]: variant, ['button-'+width]: width}" v-else-if="variant == 'social-twitter'">
        <svgicon name="twitter" /><slot></slot>
    </button>
    <button class="button" v-bind:class="{['variant-'+variant]: variant, ['button-'+width]: width}" v-else>
        <slot></slot>
    </button>
</template>
<script>
    export default {
        name: 'Button',
        components: {},
        props: {
            variant: {
                type: String,
                default: 'default'
            }, width: {
                type: String,
                default: 'inline'
            },
            size: {
                type: String,
                default: 'default'
            }
        },
        data () {
            return {

            }
        },
        computed: {

        },
        mounted () {

        },
        methods: {
        }
    }

</script>
<style src="./Button.scss" lang="scss"></style>
